import { Button } from "components/DesignSystem/Button/Button";
import { LogoutIcon } from "components/icons/LogoutIcon";
import Logo from "components/inkleLogo";
import authContext from "jwt_context&axios/authContext";
import { ReactNode, useContext } from "react";

export const VerifyCardWrapper = ({ children }: { children: ReactNode }) => {
  const { logoutUser } = useContext(authContext);

  return (
    <div className="t-min-h-screen t-flex t-items-center t-justify-center">
      <div className="t-w-[560px] t-border t-border-solid t-border-neutral-10 t-rounded-t-lg t-bg-white t-shadow-light-30 t-p-8">
        <div className="t-flex t-items-center t-justify-between">
          <Logo className="!t-mb-0" />

          <Button customType="ghost" size="small" onClick={logoutUser}>
            <LogoutIcon />
            <span className="t-ml-1 t-text-body-sm t-font-medium">Logout</span>
          </Button>
        </div>
        <div className="t-mt-[60px] t-space-y-6">{children}</div>
      </div>
    </div>
  );
};
